
import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component({
  components: {},
})
export default class PagePagination extends Vue {
  process: any;

  @Prop({
    type: Number,
    default: 0,
  })
  private readonly total!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private readonly perPage!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private readonly page!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private readonly pageCount!: number;

  getHref(pageNumber: number) {
    let host = 'https://';

    host += process.server ? this.$nuxt.context.req.headers.host : window.location.host;

    host += this.$route.fullPath.includes('page=')
      ? this.$route.fullPath.replace(/page=\d+/, `page=${pageNumber}`)
      : `${this.$route.fullPath}${(this.$route.fullPath || '').includes('?') ? '&' : '?'}` + `page=${pageNumber}`;

    return host;
  }

  get pagination() {
    const { page } = this;
    const siblingCount: any = 2;
    const boundaryCount: any = 1;
    const count: any = this.pageCount;
    const range: any = function range(start: any, end: any) {
      const length = end - start + 1;
      return Array.from(
        {
          length: length,
        },
        (_, i) => start + i,
      );
    };

    const startPages: any = range(1, Math.min(boundaryCount, count));
    const endPages: any = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart: any = Math.max(Math.min(page - siblingCount, count - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    const siblingsEnd: any = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages[0] - 2);

    const params2: any = siblingsStart > boundaryCount + 2 ? ['start-ellipsis'] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : [];
    const params3: any = range(siblingsStart, siblingsEnd);
    const params4: any = siblingsEnd < count - boundaryCount - 1 ? ['end-ellipsis'] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : [];
    const items: any = [].concat(startPages, params2, params3, params4, endPages);

    return items.map((item: any) => {
      if (typeof item === 'number') {
        return { title: item, page: item };
      }

      return { title: '...', disabled: true };
    });
  }

  onChange(page: number | undefined): void {
    if (typeof page !== 'number') {
      return;
    }

    this.$emit('change', page);
  }
}
